import { render } from "./TicketsMainPage.vue?vue&type=template&id=64f37e50"
import script from "./TicketsMainPage.vue?vue&type=script&lang=js"
export * from "./TicketsMainPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__